module.exports = new __parcel__URL__("Luke_EN.6bfe365d.png").toString();